import { render, staticRenderFns } from "./login-socials.vue?vue&type=template&id=1c6db35a&scoped=true"
import script from "./login-socials.vue?vue&type=script&lang=js"
export * from "./login-socials.vue?vue&type=script&lang=js"
import style0 from "./login-socials.vue?vue&type=style&index=0&id=1c6db35a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6db35a",
  null
  
)

export default component.exports